<script setup>
import Container from "@/components/common/other/Container"
import GridColumn from "@/classes/component-classes/GridColumn";
import GridCellDetail from "@/components/common/other/GridCellDetail";
import DateInformationTooltip from "@/components/common/other/DateInformationTooltip";
import StaticTooltip from "@/components/common/other/StaticTooltip";
import NoDataFoundBanner from "@/components/shipments/NoDataFoundBanner";
import TextArea from "@/components/common/input/TextArea";

import {inject} from 'vue'

const shipments = inject("shipments");

function getCorrectDate(date) {

  if (date.actual === '') return date.est
  return date.actual
}

</script>

<template class="cmp-consignment-and-milestones">
  <div id="Vue-3-component-consignment-and-milestones" class="cmp-consignment-and-milestones_wrapper">
    <Container
        style="width: 100%;"
        height="140"
        title="Consignment Details">
      <div class="cmp-consignment-and-milestones_consignment-detail-wrapper cmp-consignment-and-milestones_dims">
        <div class="label">Pieces</div>
        <div class="cmp-consignment-and-milestones_data">{{shipments.viewShipment.consignmentDetails.nop}}</div>
        <div class="label">Weight</div>
        <div class="cmp-consignment-and-milestones_data">{{shipments.viewShipment.consignmentDetails.weight}}</div>
        <div class="label">Chargeable Weight</div>
        <div class="cmp-consignment-and-milestones_data">{{shipments.viewShipment.consignmentDetails.actualWeight}}</div>
        <div class="label">Cube</div>
        <div class="cmp-consignment-and-milestones_data">{{shipments.viewShipment.consignmentDetails.cube}}</div>
      </div>
      <TextArea
          style="margin-top: 10px;"
          v-model="shipments.viewShipment.consignmentDetails.description"
          placeholder="Goods Description"
          :readonly="true"
          :height="80"
          :width="860">
      </TextArea>
<!--      <div class="cmp-consignment-and-milestones_consignment-detail-wrapper">-->
<!--        <div class="label" style="margin-left: -10px;">Description</div>-->
<!--        <div class="cmp-consignment-and-milestones_data" style="width: 778px; height: 65px; align-items: normal; margin-top: 6px; margin-left: -5px;">{{shipments.viewShipment.consignmentDetails.description}}</div>-->
<!--      </div>-->
      <template v-slot:icon>
        <i class="fa-solid fa-cubes" style="color: #315f83;"></i>
      </template>
    </Container>
    <Container
        style="width: 100%;"
        height="140"
        title="Milestone Information">
      <template v-slot:icon>
        <i class="fa-solid fa-list-check" style="color: #dd7b01;"></i>
      </template>
      <div style="overflow-x: auto; height: 50px;">
        <div class="cmp-consignment-and-milestones_date-wrapper">
          <div v-for="item in shipments.viewShipment.milestoneInformation.dateColumns" class="cmp-consignment-and-milestones_milestone-dates">
            <div class="label">{{item.title}}</div>
            <div v-for="data in shipments.viewShipment.milestoneInformation.dates">
              <GridCellDetail
                  :notGridCell="true"
                  v-model:cellColor="data[item.key].status">
                <template #details>
                  <DateInformationTooltip
                      :estDate="data[item.key].est"
                      :estTime="data[item.key].estimatedTime"
                      :actualDate="data[item.key].actual">
                  </DateInformationTooltip>
                </template>
                <template #cell-data>
                  <div class="cmp-consignment-and-milestones_date-data">{{getCorrectDate( data[item.key])}}</div>
                </template>
              </GridCellDetail>
            </div>
          </div>
        </div>
      </div>
      <div v-if="shipments.viewShipment.milestoneInformation.milestones.length > 0" class="cmp-consignment-and-milestones_milestone-details">
        <div class="cmp-consignment-and-milestones_headers">
          <div class="label" style="width: 160px;">DateTime</div>
          <div class="label" style="width: 280px;">Milestone</div>
          <div class="label" style="width: 253px;">Comments</div>
          <div></div>
        </div>
        <div v-for="item in shipments.viewShipment.milestoneInformation.milestones" :key="item.id" class="cmp-consignment-and-milestones_data-boxes-wrapper">
          <StaticTooltip :icon="false">
            <template #content>
              {{item.dateTime}}
            </template>
            <div style="width: 150px;">{{item.dateTime}}</div>
          </StaticTooltip>
          <StaticTooltip :icon="false">
            <template #content>
              {{item.milestone}}
            </template>
            <div style="width: 270px; white-space: nowrap;">{{item.milestone}}</div>
          </StaticTooltip>
          <StaticTooltip :icon="false" width="340">
            <template #content>
              {{item.comments}}
            </template>
            <div style="width: 350px; white-space: nowrap; ">{{item.comments}}</div>
          </StaticTooltip>
        </div>
      </div>
      <div v-else class="cmp-consignment-and-milestones_no-milestones">
        <NoDataFoundBanner>No Milestones Data</NoDataFoundBanner>
      </div>
    </Container>
  </div>
</template>

<style lang="scss" scoped>

.cmp-consignment-and-milestones {

  &_wrapper {
    display: flex;
    gap: 10px;
    width: 100%;
  }

  &_consignment-detail-wrapper {
    padding: 10px;
    display: grid;;
    grid-template-columns: 70px 90px 50px 160px 120px 160px 50px 120px;
    grid-column-gap: 5px;
    font-size: 13px;
  }

  &_consignment-detail-wrapper &_data {
    display: flex;
    align-items: center;
    border: 1px solid #e2e2e2;
    height: 18px;
    padding: 3px;
    margin-right: 40px;
    background: white;
    border-radius: 4px;
    width: 80%;
  }

  &_dims {
    width:fit-content;
    background: #eceff1;
    border-radius: 4px;
    padding: 6px;
  }

  &_dims div {
    display: flex;
    align-items: center;
  }

  &_date-wrapper {
    width: fit-content;
    min-width: 868px;
    display: flex;
    gap: 20px;
    background: #eceff1;
    border-radius: 4px;
    height: 38px;
  }

  &_milestone-dates {
    font-size: 12px;
    display: flex;
    flex: none;
    align-items: center;
    padding-left: 5px;
    gap: 8px;
  }

  &_date-data {
    display: flex;
    align-items: center;
    align-content: center;
    height: 26px;
    overflow: hidden;
  }

  &_milestone-details {
    position: relative;
    margin-top: 10px;
    overflow-y: auto;
    height: 80px;
  }

  &_headers {
    display: flex;
    gap: 20px;
    padding: 4px;
  }

  &_data-boxes-wrapper {
    display: flex;
    gap: 20px;
  }

  &_data-boxes-wrapper div {
    display: flex;
    align-items: center;
    height: 16px;
    border: 1px solid #e7e7e7;
    padding: 5px;
    margin-top: 5px;
    border-radius: 2px;
    overflow: hidden;
    font-size: 13px;
    background-color: white;
  }

  &_no-milestones {
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}

</style>
